<template>
  <div class="w-100 h-100">
    <dv-border-box-7>
      <div class="h-100">
        <div class="w-100 h-100 p-tb" id="issueUserRateEchart"></div>
      </div>
      <div class="tooltip-container">
        <el-tooltip effect="dark" content="显示本年的EI数据，按创建时间查询，查询审批通过的EI，按类别分组" placement="top-start">
          <i class="el-icon-question" style="font-size:16px;"></i>
        </el-tooltip>
      </div>
    </dv-border-box-7>
  </div>
</template>

<script>
export default {
  name: "lpa-center",
  props: {
    beans: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      dataList: this.beans,
      startCharts: null,
    };
  },
  watch: {
    beans: {
      handler: function (val, oldVal) {
        this.dataList = val;
        this.lineEchart();
      },
      deep: true,
    },
  },
  mounted() {
    // this.lineEchart();
  },
  methods: {
    fontSize(res) {
      let docEl = document.documentElement,
        clientWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
      if (!clientWidth) return;
      let fontSize = 100 * (clientWidth / 1920);
      return res * fontSize;
    },
    lineEchart() {
      var lineEchart = this.$echarts.init(
        document.getElementById("issueUserRateEchart")
      );

      var data = this.dataList;

      const xAxis = [];
      const lineData = [];
      const barData = [];
      let periodText = "";
      data.forEach((item) => {
        switch (item.period) {
          case "year":
            periodText = "年";
            break;
          case "month":
            periodText = "月";
            break;
          case "day":
            periodText = "日";
        }
        this.tableTitle = periodText;
        xAxis.push(item.periodValue);
        barData.push(parseFloat(item.eiCount));
      });
      var option = {
        title: {
          text: "EI分类汇总",
          left: "10",
          textStyle: {
            color: "#ffffff",
            fontSize: "18",
          },
        },
        tooltip: {
          trigger: "axis",
          extraCssText: 'z-index: 99 !important;',
        },
        legend: {
          data: ["EI"],
          right: 5,
          textStyle: {
            color: "#ffffff", //字体颜色
            fontSize: 14,
          },
          itemGap: 2,
          show:false
        },
        grid: {
          left: "10",
          right: "0",
          bottom: "0",
          top: 55,
          y2: 40,
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: xAxis,
            axisPointer: {
              type: "shadow",
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            axisLabel: {
              interval: 0,
             // rotate: 15,
            },
          },
        ],
        yAxis: [
          {
            nameTextStyle: {
              fontSize: 14,
            },
            type: "value",
            min: 0,
            axisLabel: {
              formatter: "{value}",
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              show: false,
            },
          }
        ],
        series: [
          {
            color: ["#4C77A1"],
            type: "bar",
            stack: "total",
            barMaxWidth: "30%",
            data: barData,
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  textStyle: {
                    //数值样式
                    color: "white",
                    fontSize: 14,
                  },
                },
              },
            },
          }
        ],
      };

      lineEchart.setOption(option);
      //图标随窗口大小缩放
      window.addEventListener("resize", function () {
        lineEchart.resize();
      });

      if (this.startCharts) {
        clearInterval(this.startCharts);
      }

      var index = 0; //显示tooltip,播放所在下标
      this.startCharts = setInterval(function () {
        lineEchart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: index,
        });
        index++;
        if (index >= data.length) {
          index = 0;
        }
      }, 2000);
    },
  },
  destroyed() {
    if (this.startCharts) {
      clearInterval(this.startCharts);
    }
  },
};
</script>


<style scoped>
.tooltip-container {
  right: 0;
  bottom: 0;
  position: absolute;
  z-index: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/ei/component/ei-type-list.vue